import React from 'react';
import PropTypes from 'prop-types';

import config from '../../../../config';

const OverlayInput = props => (
  <div className="u-flex u-align-items-center">
    <span className="u-mr-">{props.label}</span>
    <div className="u-position-relative">
      <input
        className="c-input"
        ref={props.inputRef}
        value={props.inputValue}
        onChange={props.onChange}
        onBlur={props.onBlur}
        onKeyDown={props.onKeyDown}
        placeholder={config.dateFormat}
      />
      <div className="c-input-error-message" display-if={!props.isValid}>
        Please enter a correct {props.label.toLowerCase()} date ({config.dateFormat})
      </div>
    </div>
  </div>
);

OverlayInput.propTypes = {
  inputRef: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  isValid: PropTypes.bool.isRequired,
  inputValue: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func.isRequired,
};

OverlayInput.defaultProps = {
  value: null,
};

export default OverlayInput;
